import { useEffect, useState } from "react";
import { IServerElement, IUseServerElementsProps } from "../types/serverElements";
import { default as serverElementsService } from "../services/serverElements";
import { useSelector } from "react-redux";
import { RootState } from "@/store";
import { useParams } from "react-router";
import { groupByGroupName } from "../utils/serverElements";
import { IServerActions } from "../types/serverActions";
import useI18n from "@/hooks/useI18n";

const useServerElements = ({
  groupName = ''
}: IUseServerElementsProps) => {
  const { isAuthenticated } = useSelector((state: RootState) => state.auth);
  const params = useParams();
  const { currentLang } = useI18n();

  const [elementsWithoutActions, setElementsWithoutActions] = useState<IServerElement[]>([]);
  const [elements, setElements] = useState<IServerElement[]>([]);
  const [links, setLink] = useState<IServerActions[]>([]);

  const elementByGroupName = groupByGroupName(elements);

  useEffect(() => {
    serverElementsService.fetchServerElementsWithoutActions({groupName})
    .then((response) => {
      setElementsWithoutActions(response);
    })
  }, [currentLang.value]);

  useEffect(() => {
    if (isAuthenticated && params.pageId) {
      const pageId = params.pageId
      serverElementsService.fetchServerElements({pageId})
      .then((response) => {
        setElements(response);
      })
    } else {
      setElements([]);
    }
  }, [isAuthenticated, params.pageId]);

  useEffect(() => {
    if (isAuthenticated && !links.length) {
      serverElementsService.fetchServerActions().then((response) => {
        setLink(response);
      })
    } else {
      setLink([]);
    }
  }, [isAuthenticated]);

  return {
    elementsWithoutActions,
    elementByGroupName,
    links,
  }

}

export default useServerElements